import { UnifiedGraftModelType } from '@graftcode/protocol'

export const FIELD_BADGE_LABELS = {
  INSTANCE: 'Instance field',
  STATIC: 'Static field',
  GLOBAL: 'Global field',
} as const

export const getFieldBadgeLabel = (type: UnifiedGraftModelType | number | string): string | undefined => {
  const typeString = String(type)
  const typeNumber = typeof type === 'number' ? type : undefined

  if (typeString === 'GLOBAL_FIELD' || typeNumber === UnifiedGraftModelType.GLOBAL_FIELD) {
    return FIELD_BADGE_LABELS.GLOBAL
  }

  if (typeString === 'STATIC_FIELD' || typeNumber === UnifiedGraftModelType.STATIC_FIELD) {
    return FIELD_BADGE_LABELS.STATIC
  }

  if (typeString === 'INSTANCE_FIELD' || typeNumber === UnifiedGraftModelType.INSTANCE_FIELD) {
    return FIELD_BADGE_LABELS.INSTANCE
  }

  console.warn('Unknown field type:', type, typeof type)
  return undefined
}
